import { render, staticRenderFns } from "./BindLine.vue?vue&type=template&id=2bce50a7&scoped=true"
import script from "./BindLine.vue?vue&type=script&lang=js"
export * from "./BindLine.vue?vue&type=script&lang=js"
import style0 from "./BindLine.vue?vue&type=style&index=0&id=2bce50a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce50a7",
  null
  
)

export default component.exports